<template>
	<fieldset id="fs-loadshift" class="px-5 px-xxl-0 pt-5 pb-5">
		<div class="container pt-5 pb-5">
			<div class="row no-gutters">
				<div class="fieldset-title">
					<i class="icon">
						<svg class="fill-blue" aria-hidden="true">
							<use xlink:href="/static/build/gfx/sprite.svg#icon-loadshift"/>
						</svg>
					</i>

					<h2 class="heading color-blue">Advanced Controls</h2>
				</div>
			</div>

			<div
				id="fieldgroup-loadshift"
				:class="{
					fieldgroup: true,
					disabled: false
				}"
			>
				<div class="row no-gutters mb-4 align-items-center">
					<h3 class="heading color-blue mr-3">Load Shift</h3>

					<button
						type="button"
						@click.prevent="formData.loadShiftToggled = !formData.loadShiftToggled"
						:class="{
							'js-btn-toggle': true,
							'toggled': formData.loadShiftToggled,
							'locked': !loadShiftEnabled
						}"
						:disabled="!loadShiftEnabled"
					>
						<i class="toggle-knob"></i>
					</button>

					<span
						v-if="formData.schematic === 'mprtp'"
						class="color-blue ml-3"
					>
						Load shifting with multi pass return to primary systems has not been proven to work in the field.
					</span>
				</div>

				<div
					:class="[
						'row',
						'no-gutters',
						'justify-content-between',
						'align-items-start',
						{ 'disabled': !formData.loadShiftToggled || !loadShiftEnabled }
					]"
				>
					<div v-if="showPercentSlider || showPeriods" class="col-7">
						<div class="field-wrap size-big">
							<LSPeriods :isEnabled="formData.loadShiftToggled && loadShiftEnabled" />

							<div class="suffix-wrap d-flex justify-content-center">
								<p class="desc visible text-tiny bold color-blue-dark"></p>
							</div>
						</div>
					</div>

					<div v-if="showPercentSlider" class="col-4">
						<div
							:class="{
								'field-wrap': true,
								'size-big': true,
								'disabled': !isAnyPeriodEnabled || !formData.loadShiftToggled || capLoadShiftAt100
							}"
						>
							<label class="color-blue-dark">
								Percent of Load Shift Captured
							</label>

							<LSPercentSlider
								:value="formData.loadShift_percent"
								:onUpdate="newVal => formData.loadShift_percent = newVal"
								:disabled="!isAnyPeriodEnabled || !formData.loadShiftToggled || capLoadShiftAt100"
							/>

							<div class="suffix-wrap d-flex justify-content-center">
								<p class="desc visible text-tiny bold color-blue-dark"></p>
							</div>
						</div>
					</div>
				</div>

				<div class="row no-gutters justify-content-between pt-5">
					<AdvancedOpts />
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import AdvancedOpts from './components/AdvancedOpts'
import LSPeriods from './components/LSPeriods'
import LSPercentSlider from './components/LSPercentSlider'
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'LoadShift',

	components: {
		AdvancedOpts,
		LSPeriods,
		LSPercentSlider,
	},

	props: {
		showPercentSlider: {
			type: Boolean,
			default: true,
		},
		showPeriods: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		formData,
	}),

	mounted() {
		// Always enable advanced controls
		this.formData.advancedControls = true
	},

	computed: {
		loadShiftIsActive () {
			return formData.advancedControls
		},

		isAnyPeriodEnabled () {
			return formData.LSperiod1_bool || formData.LSperiod2_bool
		},

		loadShiftEnabled () {
			return formData.schematic !== 'mprtp'
		},

		isDualFuelSchematic () {
			return ['sprtp_series', 'mprtp_series', 'gas_swingtank', 'gas_parallel'].includes(formData.schematic)
		},

		isCustomLoadOrNonMultifamily () {
			return formData.buildingType !== 'multi_family' || formData.customLoadMethod !== 'ignCL'
		},

		// Dual-fuel schematics, non-multifamily buildings, and any use of a
		// custom load shape always capture 100% of load shift - Load Shift
		// itself stays available, but the percent-captured slider is locked.
		capLoadShiftAt100 () {
			return this.isDualFuelSchematic || this.isCustomLoadOrNonMultifamily
		},
	},

	watch: {
		'formData.loadShiftToggled'(newVal) {
			if (newVal && this.loadShiftEnabled) {
				// Enable Period 2 when Load Shift is toggled on
				this.formData.LSperiod2_bool = true
			}
		},

		'formData.schematic': {
			handler(newVal) {
				// Turn off Load Shift when mprtp is selected
				if (newVal === 'mprtp') {
					this.formData.loadShiftToggled = false
				}

				this.applyLoadShiftCap()
			},
			immediate: true,
		},

		'formData.buildingType' () {
			this.applyLoadShiftCap()
		},

		'formData.customLoadMethod' () {
			this.applyLoadShiftCap()
		},
	},

	methods: {
		applyLoadShiftCap () {
			if (this.capLoadShiftAt100) {
				this.formData.loadShift_percent = 100
			}
		},
	},
}
</script>
